import createReducer from 'lib/create-reducer'
import { constants } from './actions'
import saga from './sagas'

export const defaultState = {
  mode: 'login',
  name: {
    placeholder: 'Full Name',
    type: 'text',
    value: ''
  },
  email: {
    type: 'email',
    placeholder: 'Email',
    value: ''
  },
  password: {
    type: 'password',
    placeholder: 'Password',
    value: ''
  },
  repeatPassword: {
    type: 'password',
    placeholder: 'Repeat Password',
    value: ''
  },
  privacyAgreed: false,
  loading: false,

  userSignupType: null,
  userSignupTypeLoading: false,
  userSignupTypeEmail: null,
  userSignupTypeOrg: null,
  userSignupTypeEmailDomains: null,
  fetchedSignupType: false,
  fetchedSignupTypeError: false
}

const loginModal = createReducer(defaultState, {
  [constants.SET_MODE]: (state, mode) => ({
    ...state,
    mode: mode,
    name: {
      ...state.name,
      error: false
    },
    email: {
      ...state.email,
      error: false
    },
    password: {
      ...state.password,
      error: false
    },
    repeatPassword: {
      ...state.repeatPassword,
      error: false
    }
  }),
  [constants.TOGGLE_PRIVACY_AGREED]: state => ({
    ...state,
    privacyAgreed: !state.privacyAgreed
  }),
  [constants.SET_FIELD]: (state, { field, value }, error) => {
    const nextState = {
      ...state,
      [field]: {
        ...state[field],
        value,
        error: !!error,
        errorMessage: error && error.message
      }
    }

    //
    // MILO:
    //       This is also enforced on the backend
    //       but causes some weirdness here if we
    //       don't do it (when logging in after signup)
    if (field === 'email') {
      nextState[field].value = value.toLowerCase()
    }

    return nextState
  },
  [constants.SUBMIT]: state => ({
    ...state,
    loading: true
  }),
  [constants.SUBMIT_SUCCESS]: state => ({
    ...state,
    password: {
      ...state.password,
      value: ''
    },
    repeatPassword: {
      ...state.repeatPassword,
      value: ''
    },
    loading: false
  }),
  [constants.SUBMIT_FAILURE]: (state, { field, error } = {}) => {
    const nextState = {
      ...state,
      loading: false
    }

    if (field && error) {
      nextState[field] = {
        ...nextState[field],
        error: true,
        errorMessage: error
      }
    }
    return nextState
  },
  [constants.FETCH_SIGNUP_TYPE]: state => ({
    ...state,
    userSignupType: null,
    userSignupTypeLoading: true,
    fetchedSignupType: false,
    userSignupTypeEmail: null,
    userSignupTypeOrg: null,
    userSignupTypeEmailDomains: null
  }),
  [constants.FETCH_SIGNUP_TYPE_SUCCESS]: (state, { userSignupType, userSignupTypeOrg, userSignupTypeEmailDomains, email }) => ({
    ...state,
    userSignupType,
    userSignupTypeLoading: false,
    fetchedSignupType: true,
    userSignupTypeEmail: email,
    userSignupTypeOrg,
    userSignupTypeEmailDomains
  }),
  [constants.FETCH_SIGNUP_TYPE_FAILURE]: (state, error) => ({
    ...state,
    userSignupType: null,
    userSignupTypeLoading: false,
    fetchedSignupType: false,
    userSignupTypeEmail: null,
    fetchedSignupTypeError: true,
    userSignupTypeOrg: null,
    userSignupTypeEmailDomains: null,
    error
  }),
  [constants.FLUSH_SIGNUP_TYPE]: state => ({
    ...state,
    userSignupType: null,
    userSignupTypeLoading: false,
    fetchedSignupType: false,
    userSignupTypeEmail: null,
    fetchedSignupTypeError: false,
    userSignupTypeOrg: null,
    userSignupTypeEmailDomains: null
  }),
  [constants.SET_USER_SIGNUP_TYPE]: (state, signupType) => ({
    ...state,
    userSignupType: signupType
  }),
  [constants.SET_USER_SIGNUP_ORG]: (state, signupOrg) => ({
    ...state,
    userSignupTypeOrg: signupOrg
  })
}, saga)

export default loginModal
